import React from 'react';
import { FileText, AlertCircle, CheckCircle } from 'lucide-react';
import { Button } from '../ui/button';

const PrePaymentDisclaimerModal = ({ isOpen, onClose, onAccept, disclaimerText }) => {
  if (!isOpen) return null;

  const defaultDisclaimer = `By proceeding with payment, you acknowledge that:

• You have reviewed all the information provided in your will document
• The details entered are accurate and complete to the best of your knowledge
• You understand that this will document is being created based on the information you have provided
• You may edit your will after payment, but changes should be made carefully

Please ensure all information is accurate before completing the payment.`;

  const displayText = disclaimerText || defaultDisclaimer;

  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-slate-900 rounded-2xl max-w-lg w-full shadow-2xl border border-slate-700 overflow-hidden">
        {/* Header */}
        <div className="bg-amber-500/10 px-6 py-4 border-b border-slate-700">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-amber-500/20 rounded-xl">
              <FileText className="w-6 h-6 text-amber-400" />
            </div>
            <div>
              <h2 className="text-xl font-bold text-white">Almost There!</h2>
              <p className="text-slate-400 text-sm">Please review before proceeding</p>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="p-6">
          <div className="bg-slate-800/50 border border-slate-700 rounded-lg p-4 mb-4">
            <div className="flex items-start gap-3">
              <AlertCircle className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" />
              <div className="text-slate-300 text-sm whitespace-pre-line">
                {displayText}
              </div>
            </div>
          </div>

          <div className="bg-emerald-500/10 border border-emerald-500/30 rounded-lg p-3">
            <div className="flex items-center gap-2">
              <CheckCircle className="w-4 h-4 text-emerald-400" />
              <span className="text-emerald-400 text-sm">
                You're one step away from completing your legally valid will
              </span>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="bg-slate-800/50 px-6 py-4 border-t border-slate-700 flex gap-3">
          <Button
            variant="outline"
            onClick={onClose}
            className="flex-1 border-slate-600 text-slate-300 hover:bg-slate-700"
            data-testid="disclaimer-go-back"
          >
            Go Back
          </Button>
          <Button
            onClick={onAccept}
            className="flex-1 bg-amber-500 hover:bg-amber-400 text-slate-900 font-semibold"
            data-testid="disclaimer-accept"
          >
            I Understand, Continue to Payment
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PrePaymentDisclaimerModal;
